import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';

import './packetSelector.scss';

class PacketSelectorCtrl {
    constructor(imagesService, dataService, config, $rootScope) {
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.config = config;

        $rootScope.$on('colorChangeEvent', () => this.refreshOptions());
        $rootScope.$on('dimensionsChangeEvent', () => this.refreshOptions());
    }

    refreshOptions() {
        this.selectedOptionId = this.dataService.data.data[0].relationships.packet.data || [-1];
        this.onInit();
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback({ selected: this.selectedPacketKeys });
        }
    }

    getImageUrl(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    getItemAttributes(item) {
        let itemData = {};

        if (angular.isDefined(item.data)) {
            itemData = this.dataService.getItem(item.data);
        } else {
            itemData = this.dataService.getItem(item);
        }
        if (angular.isDefined(itemData.attributes)) {
            return itemData.attributes;
        }
        return itemData;
    }

    getGlazingSpacerImage(glazingSpacer) {
        let imageSrc = null;
        const glazingSpacerAttributes = this.getItemAttributes(glazingSpacer);
        const glazingChambers = this.dataService.getAttributeOptions('glazing').find(
            glazing => glazing.id == this.dataService.getSelectedOptionId('glazing')
        ).attributes.chambers;

        if (Number(glazingChambers) === 1 && glazingSpacerAttributes.image_2_glass) {
            imageSrc = '/files/glazingspacers/' + glazingSpacerAttributes.image_2_glass;
        }
        if (Number(glazingChambers) === 2 && glazingSpacerAttributes.image_3_glass) {
            imageSrc = '/files/glazingspacers/' + glazingSpacerAttributes.image_3_glass;
        }
        return imageSrc;
    }

    ifNotPacket(item) {
        if (angular.isArray(item.data)) {
            return false;
        }
        return true;
    }

    onInit() {
        if (this.selectedOptionId.length) {
            this.selectedPacketKeys = [];
            forEach(this.selectedOptionId, (el) => {
                this.selectedPacketKeys.push(el.id);
            });
        } else {
            this.selectedPacketKeys = [-1];
        }

        if (this.options.indexOf(this.config.defaultPacket) < 0) {
            this.options.unshift(this.config.defaultPacket);
        }
    }

    openModal(option) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: option.attributes.name,
                modalContent: option.attributes.modalContent
            });
        }
    }

    resetClassic() {
        const classicIndex = this.selectedPacketKeys.indexOf(-1);
        if (classicIndex >= 0) {
            this.selectedPacketKeys.splice(classicIndex, 1);
        }
    }

    toggleSelectedPackage(option) {
        if (option.id === -1) {
            this.selectedPacketKeys = [-1];
            this.dataService.removePacketAccessories();
        } else if (this.selectedPacketKeys.indexOf(option.id) >= 0) {
            this.selectedPacketKeys.splice(this.selectedPacketKeys.indexOf(option.id), 1);
            this.resetClassic();
            this.dataService.removePacketAccessories(option.id);
        } else {
            this.selectedPacketKeys.push(option.id);
            this.resetClassic();
        }
        if (!this.selectedPacketKeys.length) {
            this.selectedPacketKeys = [-1];
        }
        this.dataService.updateSelectedOptions('packet', this.selectedPacketKeys, 'packet');
    }
}

PacketSelectorCtrl.$inject = ['imagesService', 'dataService', 'config', '$rootScope'];

export default PacketSelectorCtrl;